import { Style } from '@/components/style';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { setWelcomeCustomerName } from '@/actions/customizeWelcome/customizeWelcomeAction';
import NameUtils from '@/components/customizeWelcome/utils/nameUtils';
import Validator from '@/utils/validator';
import { ReactComponent as Warn } from '@/assets/img/warn.svg';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';

const { alertColor, blackColor, gray3Color } = new Style().getUiConfig();

function WelcomeName({
  webStoreVo,
  selectedServeType,
  selectedTakeOutServeType,
}) {
  const intl = useIntl();
  const dispatch = useDispatch<any>();
  const [name, setName] = useState('');
  const showName = NameUtils.showNameField(
    webStoreVo,
    selectedServeType,
    selectedTakeOutServeType
  );
  const isNameRequired = NameUtils.checkNameRequired(
    webStoreVo,
    selectedServeType,
    selectedTakeOutServeType
  );
  const [isNameValid, setNameValid] = useState(false);

  const isCustomerNameValid = useSelector(
    (state: RootStateOrAny) => state.customizeWelcomeReducer.isCustomerNameValid
  );

  const customerName = useSelector(
    (state: RootStateOrAny) => state.customizeWelcomeReducer.customerName
  );

  useEffect(() => {
    setNameValid(isCustomerNameValid);
  }, [isCustomerNameValid]);

  useEffect(() => {
    setNameValid(Validator.nameValidator(name, isNameRequired));
  }, [name]);

  useEffect(() => {
    setName(customerName);
  }, [customerName]);

  const onChangeName = (e) => {
    // orderVo.customerName = e.target.value;
    dispatch(setWelcomeCustomerName(e.target.value));
    setName(e.target.value);
  };

  return (
    <div>
      {showName && (
        <div>
          <div className="d-flex justify-content-center">
            <input
              style={{
                padding: '10px',
                width: '100%',
                height: '42px',
                fontSize: '16px',
                borderRadius: '10px',
                border: `1px solid ${isNameValid ? gray3Color : alertColor}`,
                color: `${isNameValid ? blackColor : alertColor}`,
              }}
              maxLength={255}
              data-testid="name"
              type="text"
              placeholder={
                isNameRequired
                  ? intl.formatMessage({
                      id: 'cart.customerInfo.name.required',
                    })
                  : intl.formatMessage({
                      id: 'cart.customerInfo.name',
                    })
              }
              defaultValue={name}
              onChange={onChangeName}
            />
          </div>
          {!isNameValid ? (
            <div
              className="d-flex align-items-center"
              style={{
                color: alertColor,
                fontSize: '12px',
                margin: '5px 0px 10px 0px',
              }}
            >
              <Warn style={{ marginRight: '5px' }} />
              {intl.formatMessage({
                id: 'cart.customerInfo.name.error',
              })}
            </div>
          ) : (
            <div style={{ marginBottom: '10px' }} />
          )}
        </div>
      )}
    </div>
  );
}

WelcomeName.defaultProps = {};

WelcomeName.propTypes = {
  webStoreVo: PropTypes.shape({
    availableServeTypes: PropTypes.arrayOf(PropTypes.string),
    availableTakeOutServeTypes: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  selectedServeType: PropTypes.string.isRequired,
  selectedTakeOutServeType: PropTypes.string.isRequired,
};

export default WelcomeName;
